import {mapActions, mapGetters} from "vuex";

export default {
    computed: {
        ...mapGetters({
            xUser: 'auth/user',
            checkXAuth: 'auth/authenticated',
        }),
    },
    methods: {
        ...mapActions({getX: 'auth/login'}),
    },
    created() {
        this.getX().then(() => {
            if (this.checkXAuth && (!this.xUser.role_id || !this.xUser.location_id || !this.xUser.selected_currency_id)) {
                this.$router.push({name: 'x'})
            }
        })
    },
}